import { Link } from 'react-router-dom';

type Brand = {
  rank: number;
  name: string;
  nameJp: string;
  score: number;
  rating: number;
  price: string;
  tag: string;
  tagColor: string;
  rankColor: string;
  borderColor: string;
  bgColor: string;
  image: string;
  initial: string;
  initialBg: string;
  description: string;
  point: string;
  officialUrl?: string;
};

const brands: Brand[] = [
  {
    rank: 1,
    name: 'ROLEX',
    nameJp: 'ロレックス',
    score: 98,
    rating: 5,
    price: '¥800,000〜',
    tag: '編集部イチオシ',
    tagColor: 'bg-amber-500 text-white',
    rankColor: 'bg-amber-400',
    borderColor: 'border-amber-300',
    bgColor: 'bg-amber-50',
    image: 'https://public.readdy.ai/ai/img_res/a0aec2af-6963-4f8f-ba15-05617f42abd9.png',
    initial: 'R',
    initialBg: 'bg-gradient-to-br from-amber-400 to-amber-600',
    description:
      '世界最高峰の時計ブランド。圧倒的なブランド力とリセールバリューの高さで、投資目的としても絶大な人気を誇ります。サブマリーナやデイトナなど名作揃い。',
    point: '資産価値◎ | 入手難易度高め',
    officialUrl: 'https://www.rolex.com/ja-jp',
  },
  {
    rank: 2,
    name: 'OMEGA',
    nameJp: 'オメガ',
    score: 92,
    rating: 5,
    price: '¥250,000〜',
    tag: 'コスパ最強',
    tagColor: 'bg-gray-600 text-white',
    rankColor: 'bg-gray-400',
    borderColor: 'border-gray-300',
    bgColor: 'bg-gray-50',
    image: 'https://static.readdy.ai/image/70a4703660d18bee8c4b43bbf221e0fa/227341177feadc643f511e7ccef021bd.png',
    initial: 'Ω',
    initialBg: 'bg-gradient-to-br from-gray-500 to-gray-700',
    description:
      'スピードマスターで月面着陸も果たした歴史あるブランド。ロレックスに次ぐ知名度とクオリティを持ちながら、比較的手の届きやすい価格帯が魅力。',
    point: 'デザイン◎ | 歴史的価値◎',
    officialUrl: 'https://www.omegawatches.jp/',
  },
  {
    rank: 3,
    name: 'Cartier',
    nameJp: 'カルティエ',
    score: 88,
    rating: 5,
    price: '¥300,000〜',
    tag: 'ファッション性No.1',
    tagColor: 'bg-rose-500 text-white',
    rankColor: 'bg-amber-700',
    borderColor: 'border-amber-200',
    bgColor: 'bg-rose-50/40',
    image: 'https://public.readdy.ai/ai/img_res/a557b5e1-8f84-4412-9d0a-eb91e0f37bde.png',
    initial: 'C',
    initialBg: 'bg-gradient-to-br from-rose-400 to-rose-700',
    description:
      'ジュエラー出身ならではの圧倒的な美しさ。タンクやサントスは時代を超えたアイコニックなデザインで、ファッションアイテムとしても最高評価。',
    point: 'デザイン最高◎ | ブランド認知◎',
    officialUrl: 'https://www.cartier.jp/',
  },
  {
    rank: 4,
    name: 'TAG Heuer',
    nameJp: 'タグ・ホイヤー',
    score: 82,
    rating: 4,
    price: '¥150,000〜',
    tag: 'スポーツ系人気',
    tagColor: 'bg-slate-500 text-white',
    rankColor: 'bg-slate-500',
    borderColor: 'border-slate-200',
    bgColor: 'bg-slate-50/40',
    image: 'https://readdy.ai/api/search-image?query=TAG%20Heuer%20Carrera%20Monaco%20sport%20chronograph%20watch%20black%20dial%20tachymeter%20bezel%20steel%20bracelet%20racing%20motorsport%20clean%20white%20background%20product%20photography%20high%20detail%20studio%20lighting&width=112&height=112&seq=tagheuer-rank-4&orientation=squarish',
    initial: 'T',
    initialBg: 'bg-gradient-to-br from-slate-500 to-slate-700',
    description:
      'モータースポーツとの深い結びつきを持つスイスブランド。カレラやモナコなど個性的なモデルが揃い、アクティブなライフスタイルに合わせやすい一本。',
    point: 'スポーツ感◎ | 価格帯◎',
    officialUrl: 'https://www.tagheuer.com/jp/ja/',
  },
  {
    rank: 5,
    name: 'SEIKO',
    nameJp: 'セイコー',
    score: 79,
    rating: 4,
    price: '¥30,000〜',
    tag: '国産ブランドNo.1',
    tagColor: 'bg-teal-600 text-white',
    rankColor: 'bg-teal-500',
    borderColor: 'border-teal-200',
    bgColor: 'bg-teal-50/40',
    image: 'https://readdy.ai/api/search-image?query=Seiko%20Prospex%20Grand%20Seiko%20automatic%20Japanese%20luxury%20watch%20silver%20dial%20steel%20case%20bracelet%20precision%20craftsmanship%20simple%20white%20background%20product%20photography%20high%20detail%20studio%20lighting&width=112&height=112&seq=seiko-rank-5&orientation=squarish',
    initial: 'S',
    initialBg: 'bg-gradient-to-br from-teal-400 to-teal-700',
    description:
      '日本が世界に誇る精工舎の流れを汲む国産ブランド。クオーツ革命の立役者として技術力は折り紙付き。グランドセイコーはスイス勢と互角以上の実力を持つ。',
    point: '耐久性◎ | コスパ◎',
    officialUrl: 'https://www.seikowatches.com/jp-ja/',
  },
  {
    rank: 6,
    name: 'CITIZEN',
    nameJp: 'シチズン',
    score: 74,
    rating: 4,
    price: '¥20,000〜',
    tag: '実用性重視派に◎',
    tagColor: 'bg-indigo-500 text-white',
    rankColor: 'bg-indigo-400',
    borderColor: 'border-indigo-200',
    bgColor: 'bg-indigo-50/40',
    image: 'https://readdy.ai/api/search-image?query=Citizen%20Eco-Drive%20solar%20powered%20Japanese%20watch%20blue%20dial%20titanium%20case%20bracelet%20modern%20elegant%20clean%20simple%20white%20background%20product%20photography%20high%20detail%20studio%20lighting&width=112&height=112&seq=citizen-rank-6&orientation=squarish',
    initial: 'Ci',
    initialBg: 'bg-gradient-to-br from-indigo-400 to-indigo-600',
    description:
      '光発電エコ・ドライブで電池交換不要という革新技術を持つ国産ブランド。実用性と信頼性を最優先する方に長年支持され続けているロングセラーモデル多数。',
    point: '実用性◎ | メンテ楽◎',
    officialUrl: 'https://citizen.jp/',
  },
];

function RankBadge({ rank }: { rank: number }) {
  if (rank === 1)
    return (
      <div className="flex flex-col items-center gap-1">
        <div className="w-10 h-10 flex items-center justify-center">
          <i className="ri-trophy-fill text-amber-500 text-3xl"></i>
        </div>
        <span className="text-xs font-bold text-amber-600">1位</span>
      </div>
    );
  if (rank === 2)
    return (
      <div className="flex flex-col items-center gap-1">
        <div className="w-10 h-10 flex items-center justify-center">
          <i className="ri-medal-fill text-gray-400 text-3xl"></i>
        </div>
        <span className="text-xs font-bold text-gray-500">2位</span>
      </div>
    );
  if (rank === 3)
    return (
      <div className="flex flex-col items-center gap-1">
        <div className="w-10 h-10 flex items-center justify-center">
          <i className="ri-medal-fill text-amber-700 text-3xl"></i>
        </div>
        <span className="text-xs font-bold text-amber-700">3位</span>
      </div>
    );
  return (
    <div className="flex flex-col items-center gap-1">
      <div className="w-10 h-10 flex items-center justify-center">
        <span className="text-2xl font-light text-gray-400">{rank}</span>
      </div>
      <span className="text-xs font-bold text-gray-400">{rank}位</span>
    </div>
  );
}

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-amber-50/30 to-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-block px-4 py-2 bg-amber-50 text-amber-600 text-sm font-medium rounded-full mb-6">
            編集部厳選
          </div>
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-4">
            人気ブランドランキング
          </h2>
          <p className="text-base text-gray-500 max-w-xl mx-auto">
            編集部が徹底比較。購入前に必見のブランド別おすすめ順位を公開します。
          </p>
        </div>

        {/* Ranking List */}
        <div className="flex flex-col gap-4">
          {brands.map((brand) => (
            <div
              key={brand.rank}
              className={`flex items-center gap-5 rounded-2xl border ${brand.borderColor} ${brand.bgColor} px-6 py-5 transition-all duration-200 hover:-translate-y-0.5 cursor-pointer`}
            >
              {/* Rank Badge */}
              <div className="flex-shrink-0 w-12">
                <RankBadge rank={brand.rank} />
              </div>

              {/* Brand Avatar */}
              <div className="flex-shrink-0">
                <div className="w-14 h-14 rounded-xl overflow-hidden bg-white border border-gray-200 flex items-center justify-center">
                  <img
                    src={brand.image}
                    alt={brand.name}
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>

              {/* Brand Info */}
              <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <span className="text-lg font-semibold text-gray-900 tracking-wide">
                    {brand.name}
                  </span>
                  <span className="text-sm text-gray-400">{brand.nameJp}</span>
                  <span
                    className={`text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${brand.tagColor}`}
                  >
                    {brand.tag}
                  </span>
                </div>

                {/* Stars */}
                <div className="flex items-center gap-1 mb-2">
                  {[...Array(5)].map((_, i) => (
                    <i
                      key={i}
                      className={`text-sm ${
                        i < brand.rating ? 'ri-star-fill text-amber-400' : 'ri-star-line text-gray-300'
                      }`}
                    ></i>
                  ))}
                  <span className="text-xs text-gray-400 ml-1">
                    スコア {brand.score}/100
                  </span>
                </div>

                <p className="text-sm text-gray-600 leading-relaxed hidden sm:block line-clamp-2">
                  {brand.description}
                </p>

                <div className="mt-1.5 text-xs text-gray-400">
                  <i className="ri-price-tag-3-line mr-1"></i>
                  価格帯：{brand.price}　／　{brand.point}
                </div>
              </div>

              {/* CTA */}
              <div className="flex-shrink-0">
                {brand.officialUrl ? (
                  <a
                    href={brand.officialUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="whitespace-nowrap text-sm font-medium px-4 py-2 rounded-full bg-white border border-amber-300 text-amber-700 hover:bg-amber-500 hover:text-white hover:border-amber-500 transition-all duration-200 cursor-pointer inline-block"
                  >
                    公式サイトへ
                  </a>
                ) : (
                  <Link
                    to={`/blog?brand=${encodeURIComponent(brand.nameJp)}`}
                    className="whitespace-nowrap text-sm font-medium px-4 py-2 rounded-full bg-white border border-amber-300 text-amber-700 hover:bg-amber-500 hover:text-white hover:border-amber-500 transition-all duration-200 cursor-pointer inline-block"
                  >
                    詳しく見る
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Footer note */}
        <p className="text-center text-xs text-gray-400 mt-8">
          ※ランキングは編集部の独自調査に基づくものです。価格・仕様は変動する場合があります。
        </p>
      </div>
    </section>
  );
}
